module.exports = __webpack_public_path__ + "img/antes_despues_178.721634b2.png";